import { useRef, useState } from "react";
import classnames from "classnames";

import Button from "@/components/Button";
import Typography from "@/components/Typography";
import WysiwygText from "@/components/WysiwygText";
import InfoIcon from "@/icons/info.svg";
import UpArrow from "@/icons/upArrow.svg";
import { useDataLayer } from "@/helpers/useDataLayer";
import { Schema } from "@/components/MetaHead/Head.interface";

import styles from "../Tabs.module.scss";
import { TranscriptInterface } from "../Tabs.interface";

const Transcript: React.FC<TranscriptInterface> = ({
  transcript,
  tags,
  authors,
  title,
  className,
}) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(true);
  const transcriptWrapper = useRef(null);
  const { pushToDataLayer } = useDataLayer();
  
  const objectToSend = {
    author: `${authors?.map(({ name }) => name)}`,
    title: title,
    type: Schema.Page,
    tag: `${tags?.map((tag) => tag.title)}`,
  };

  const toogleTranscript = () => {
    setIsCollapsed((prevState) => {
      if (prevState) {
        pushToDataLayer("transcript_read_more", objectToSend);
        return !prevState;
      }
      transcriptWrapper.current.scrollIntoView();
      return true;
    });
  };

  return (
    <div
      className={classnames(styles.transcript, className)}
      ref={transcriptWrapper}
    >
      <div className={styles.info}>
        <InfoIcon className={styles.icon} />
        <Typography component="p" variant="small">
          Transkrypt tego epizodu został wygenerowany automatycznie. Mogą
          występować w nim małe błędy językowe, gramatyczne oraz składniowe.
        </Typography>
      </div>
      <div
        className={classnames(
          styles.textContainer,
          !isCollapsed && styles.expanded
        )}
      >
        <WysiwygText data={transcript} />
      </div>
      <div className={classnames(styles.more, !isCollapsed && styles.expanded)}>
        <Button
          variant="secondary"
          onClick={toogleTranscript}
          className={styles.moreButton}
        >
          {isCollapsed ? (
            "Czytaj więcej "
          ) : (
            <>
              <UpArrow />
              Zwiń transkrypcję
            </>
          )}
        </Button>
      </div>
    </div>
  );
};

export default Transcript;
